import React, { useEffect, useState } from 'react'
import NavItem from './nav-item'
import AppLogo from './app-logo'
import SidebarUser from './sidebar-user'
import HomeIcon from 'icon/home'
import ScanIcon from 'icon/scanIcon'
import SpeakerIcon from 'icon/speaker'
import ChartIcon from 'icon/chart'
import WebhookIcon from 'icon/webhookicon'
import BroadcastIcon from 'icon/broadcasticon'
import StarIcon from 'icon/Star-Icon'
import CampaignsIcon from 'icon/campaigns'
import { PREMIUM_APPS } from 'enums'
import ChatIcon from 'icon/chatIcon'
import TicketIcon from 'icon/ticketIcon'
import { useAgency } from 'context/agency'
import GraphIcon from 'icon/graph'
import BasicinfoIcon from 'icon/basicinfo'
import TeamIcon from 'icon/team'
import LocationIcon from 'icon/locationicon'
import KeyIcon2 from 'icon/key'
import LinkIcon from 'icon/link'
import BillIcon from 'icon/bill'
import ButtonGradient from 'component/Buttons/dashboard-btn'
import SideNAvButtonGradient from 'component/Buttons/sidenav-btn'
import { useNavigate } from 'react-router-dom'
import GiftIcon from 'icon/gift'
import WalletIcon from 'icon/walleticon'
import SnapshotIcon from 'icon/SnapshotIcon'
import { useLocationInfo } from 'context/location'
import { useTranslation } from 'context/translation'
import MessageIcon from 'icon/message'
import MessageIcon2 from 'icon/message2'
import GroupIcon from 'icon/groupicon'
import MobileScreenIcon from 'icon/mobilescreen'
import CrownIcon from 'icon/crown-icon'
import homeIcon from 'icon/nav-home.png'
import customersIcon from 'icon/nav-customers.png'
import cardsIcon from 'icon/nav-cards.png'
import transactionsIcon from 'icon/nav-transactions.png'
import scannerIcon from 'icon/nav-scanner.png'
import notificationIcon from 'icon/nav-notification.png'
import locationsIcon from 'icon/nav-locations.png'
import teamIcon from 'icon/nav-team.png'
import campaignsNavIcon from 'icon/nav-campaigns.png'
import walaaLogoEn from 'assets/images/walaa-logo-en.png'
import walaaLogoAr from 'assets/images/walaa-logo-ar.png'

const NavIcon = ({ src }) => (
  <img src={src} alt='' className='w-6 h-6 object-contain shrink-0' />
)

const menu = [
  {
    label: 'General',
    key: 'general',
    children: [
      {
        label: 'Home',
        path: './dashboard',
        icon: <NavIcon src={homeIcon} />,
        key: 'dashboard',
      },
      {
        label: 'Customers',
        path: './customers',
        icon: <NavIcon src={customersIcon} />,
        key: 'customer',
      },
      {
        label: 'Cards',
        path: './campaigns',
        icon: <NavIcon src={cardsIcon} />,
        key: 'campaign',
      },
      {
        label: 'Transactions',
        path: './transactions',
        icon: <NavIcon src={transactionsIcon} />,
        key: 'transactions',
      },
      {
        label: 'Scanner',
        path: './scanner',
        icon: <NavIcon src={scannerIcon} />,
        key: 'scanner',
      },
    ],
  },
  {
    label: 'Marketing',
    key: 'marketing',
    children: [
      {
        label: 'Campaigns',
        path: './broadcast',
        icon: <NavIcon src={campaignsNavIcon} />,
        key: 'brodcast',
      },
    ],
  },
  {
    label: 'Other',
    key: 'other',
    children: [
      // T122: this entry is geofenced push notifications, not a location/branch entity.
      // It was labelled "Locations" with the same icon as Branches directly above it, so
      // merchants read the two rows as the same feature listed twice. The route is left
      // as ./geo-location — renaming it would break existing links for no visible gain.
      {
        label: 'Geo-Push',
        path: './geo-location',
        icon: <NavIcon src={notificationIcon} />,
      },
      {
        label: 'Branches',
        path: './branches',
        icon: <NavIcon src={locationsIcon} />,
        key: 'branches',
      },
      {
        label: 'Team',
        path: './team',
        icon: <NavIcon src={teamIcon} />,
        key: 'team',
      },
    ],
  },
]

const settings = [
  {
    label: 'General Info',
    path: './settings/generalinfo',
    icon: <BasicinfoIcon />,
  },
  {
    label: 'Billing',
    path: './settings/billings',
    icon: <BillIcon />,
  },
  {
    label: 'ApiKey',
    path: './settings/apikey',
    icon: <KeyIcon2 />,
  },
]

function Sidebar(className) {
  const { agency } = useAgency()
  const { saasPlan } = useLocationInfo()
  const { isRTL, t } = useTranslation()
  const [openSideMenu, setOpenSideMenu] = useState(false)
  const [showSettings, setShowSettings] = useState(
    window.location.pathname.includes('settings'),
  )
  const [filteredMenu, setFilteredMenu] = useState(menu)
  const navigate = useNavigate()
  const sidenav_bg_color =
    agency?.location_config?.sidenav_bg_color || '#ef4523'
  const s_text_color = agency?.location_config?.sidenav_text_color

  const renderItem = (menu_item) => {
    if (menu_item.children) {
      if (!menu_item.children.length) return null
      return (
        <div key={menu_item.label}>
          <div
            className='px-2 pt-4 pb-1 text-xs font-semibold uppercase tracking-wider'
            style={{ color: '#ffffff', opacity: 0.7 }}
          >
            {t(menu_item.label)}
          </div>
          <ul className='space-y-1'>
            {menu_item.children.map((child) => (
              <NavItem key={child.label} {...child} />
            ))}
          </ul>
        </div>
      )
    }
    return (
      <div key={menu_item.label}>
        <NavItem {...menu_item} />
      </div>
    )
  }

  useEffect(() => {
    // Filter children by saas plan features (when set), keeping the groups
    if (saasPlan?.features?.length) {
      const filtered = menu
        .map((group) => ({
          ...group,
          children: group.children?.filter(
            (child) =>
              !child.key ||
              saasPlan.features.find((key) => key.includes(child.key)),
          ),
        }))
        .filter((group) => group.children?.length)
      setFilteredMenu(filtered)
    } else {
      setFilteredMenu(menu)
    }
  }, [saasPlan])

  return (
    <div className=''>
      <button
        type='button'
        className={`fixed top-3 z-50 inline-flex items-center p-2 text-sm text-gray-500 bg-white rounded-lg shadow sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 start-3`}
        onClick={() => setOpenSideMenu(!openSideMenu)}
      >
        <span className='sr-only'>Open sidebar</span>
        <svg
          className='w-6 h-6'
          aria-hidden='true'
          fill='currentColor'
          viewBox='0 0 20 20'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            clipRule='evenodd'
            fillRule='evenodd'
            d='M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z'
          />
        </svg>
      </button>
      <aside
        style={{
          backgroundColor: sidenav_bg_color,
        }}
        className={`h-screen fixed top-0 z-40 w-64 transition-transform bg-white sm:translate-x-0 flex flex-col md:start-0 ${openSideMenu ? 'transform-none' : isRTL ? 'translate-x-full' : '-translate-x-full'}`}
      >
        <div className='min-h-[67px] flex flex-col justify-center items-center mb-2'>
          <img
            src={isRTL ? walaaLogoAr : walaaLogoEn}
            alt='Walaa'
            // The logo PNGs are walaa-orange, which disappears on the (orange by
            // default / dark when overridden) sidebar background. Force it light so
            // it stays visible on any colored sidenav_bg_color.
            className='h-10 w-4/5 mt-2 object-contain brightness-0 invert'
            onError={(e) => {
              e.target.style.display = 'none'
            }}
          />
        </div>

        <div
          className={`flex-1 min-h-0 px-3 pb-4 overflow-y-auto ${
            sidenav_bg_color ? '' : 'bg-white'
          } `}
        >
          {showSettings && (
            <div class='my-3'>
              <SideNAvButtonGradient
                type='button'
                onClick={() => {
                  setShowSettings(false)
                  navigate('/')
                }}
                className={'w-full pb-2'}
              >
                {t('Go Back')}
              </SideNAvButtonGradient>
            </div>
          )}
          <ul className='space-y-2 font-medium'>
            {(showSettings ? settings : filteredMenu).map((menu_item) =>
              renderItem(menu_item),
            )}
          </ul>
        </div>

        {/* Footer: Settings button + user identity block */}
        <div className='px-3 pb-2'>
          {!showSettings && (
            <SideNAvButtonGradient
              type='button'
              onClick={() => {
                setShowSettings(true)
                navigate('./settings/')
              }}
              className={'w-full pb-2'}
            >
              {t('Settings')}
            </SideNAvButtonGradient>
          )}
          <SidebarUser />
        </div>
      </aside>
    </div>
  )
}

export default Sidebar
